import { OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';

export abstract class AbmHasRefresher implements OnInit, OnDestroy {

    protected refresher: Subscription;
    protected refreshInt: number = null;

    constructor() { }

    ngOnInit(): void {
        this.refreshInt = this.setInterval();
        this.refreshData();

        if (this.refreshInt != null && this.refreshInt > 0) {
            this.refresher = interval(this.refreshInt * 1000).subscribe(() => {
                this.refreshData();
            });
        }
    }

    ngOnDestroy(): void {
        if (this.refresher) {
            this.refresher.unsubscribe();
            this.refresher = null;
        }
    }

    protected abstract setInterval(): number;

    protected abstract refreshData(): void;
}
